import FullWidth5050Image from "@/components/5050ImageFullWidth.vue";
import { builderCta } from "@/helpers/builder-init/index";
import { useColors } from "@/helpers/composables/useColors";
const { colors } = useColors();
export const fullWidth5050Image = {
    component: FullWidth5050Image,
    name: "5050ImageFullWidth",
    models: ["category-landing-content", "campaign-content"],
    inputs: [
        {
            name: "image",
            friendlyName: "Image",
            type: "file",
            allowedFileTypes: ["jpeg", "png", "svg"]
        },
        {
            name: "imageAlt",
            friendlyName: "Image Alt",
            type: "string"
        },
        {
            name: "contentPosition",
            friendlyName: "Content Position",
            type: "string",
            enum: ["image-left", "image-right"]
        },
        {
            name: "textProps",
            friendlyName: "Text Properties",
            type: "object",
            subFields: [
                {
                    name: "textPosition",
                    friendlyName: "Text Position",
                    type: "string",
                    enum: ["left", "right", "center"],
                    defaultValue: "center"
                },
                {
                    name: "textAlignment",
                    friendlyName: "Text Alignment",
                    type: "string",
                    enum: ["left", "right", "center"],
                    defaultValue: "center"
                },
                {
                    name: "bgColor",
                    friendlyName: "Background Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "texturedBackground",
                    friendlyName: "Textured Background",
                    type: "file",
                    allowedFileTypes: ["jpeg", "png", "svg"]
                },
                {
                    name: "collabBadges",
                    friendlyName: "Collab Badges",
                    type: "list",
                    subFields: [
                        {
                            name: "badge",
                            type: "file",
                            allowedFileTypes: ["jpeg", "png", "svg"]
                        }
                    ]
                },
                {
                    name: "textColor",
                    friendlyName: "Text Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "eyeBrowColor",
                    friendlyName: "Eyebrown Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "titleColor",
                    friendlyName: "Title Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "eyebrow",
                    friendlyName: "Eyebrow",
                    type: "string"
                },
                {
                    name: "title",
                    friendlyName: "Title",
                    type: "string"
                },
                {
                    name: "description",
                    friendlyName: "Description",
                    type: "richText"
                },
                {
                    name: "descriptionPosition",
                    friendlyName: "Description Position",
                    type: "string",
                    defaultValue: "above cta",
                    enum: ["above cta", "below cta"]
                },
                {
                    name: "cta",
                    friendlyName: "CTA",
                    type: "object",
                    defaultValue: builderCta.defaultValue,
                    subFields: [...builderCta.subFields]
                }
            ]
        }
    ]
};
